import {IProductInfo} from "../product/IProductInfo";
import {IManagerResearchModel} from "./IManagerResearchModel";

export class ManagerGroup implements IManagerResearchModel {
    constructor(public managerBackstopId: number,
                public name: string,
                public products: IProductInfo[] = []) {
    }
}
